import React from "react";
import {Link} from "react-router-dom";
import DimensionInfo from "../models/DimensionInfo"
import DimensionIcon from "./DimensionIcon"

import './OwnDimensionItem.css';

const OwnDimensionItem: React.FC<{data: DimensionInfo}> = (props) => {

    return (
        <div className="dimension-item">
            <Link to={`/edit-dimension?dim=${props.data.id}`}>
                <div className="d-flex flex-row align-items-center">
                    <div className="dimension-icon-wrap">
                        <DimensionIcon dimId={props.data.id}/>
                    </div>
                    <h4>{props.data.name}</h4>
                </div>
            </Link>
        </div>
    );
};

export default OwnDimensionItem;
